module.exports = __webpack_public_path__ + "images/FUSA_icons/092-shield.8ddb47bfd5c04abf1d9ead181e4dbc38.svg";